<template>
  <div>
    <van-skeleton title animate :row="12" round="true" :loading="loading_ske">
      <div class="titles">
        公告列表
        <Icon type="md-add-circle" class="add01" @click="onModel1"/>
      </div>
      <Table border ref="selection" :columns="columns7" :data="data6" :loading="loading"></Table>
      <div class="role02">
        <Page :total="total" @on-change="nextPage"/>
      </div>

      <Modal
        v-model="modal1"
        title="添加公告"
        :mask-closable="false"
        @on-ok="add"
        @on-cancel="">
        <Input v-model="title">
          <span slot="prepend">标题</span>
        </Input>
        <Input v-model="remark" type="textarea" :rows="4" placeholder="请输入公告内容..." class="modal01"/>
      </Modal>
    </van-skeleton>
  </div>
</template>

<script>
  import httpCom from '@/api/Com';
  import util from "../../util/util";
  export default {
    name: "newList",
    data() {
      return {
        columns7: [
          {
            title: '公司名称',
            key: 'companyName',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.companyName)
              ]);
            }
          },
          {
            title: '公告标题',
            key: 'title'
          },
          {
            title: '审核状态',
            key: 'shStatus'
          },
          {
            title: '发布时间',
            key: 'ctime'
          },
          {
            title: '操作',
            key: 'action',
            width: 200,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    icon:'ios-create-outline'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    icon:'md-close-circle'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delNew(params.index)
                    }
                  }
                }, '删除'),
              ]);
            }
          }
        ],
        data6: [],
        loading_ske:true,     //骨架屏显示
        page:1,               //页数
        pageSize:10,          //显示条数
        total:0,              //列表总数
        loading:false,        //是否加载
        modal1:false,         //是否显示选择模块
        title:'',             //添加时输入的标题
        remark:'',            //添加时输入的公告内容
        xzid:'',              //选中的ID
        is_edit:false,        //是否为编辑模式
      }
    },
    mounted() {
      var me = this;
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        mobile:user.mobile,
        sign:user.sign,
        page:me.page,
        pageSize:me.pageSize,
        companyId:user.companyId
      }
      if (user.companyId == 1) {
        data.companyId = '';
      }
      httpCom.newList(data).then(res => {
        me.data6 = res.data.dataList;
        console.log(me.data6);
        me.data6.forEach(function (item,index) {
          if (item.state == 0) {
            me.$set(item,'shStatus','未审核');
          } else {
            me.$set(item,'shStatus','已审核');
          }
        })
        me.total = res.data.totalNum;
        me.loading_ske = false;
      })
    },
    methods:{
      nextPage(e){//下一页
        var me = this;
        me.loading = true;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          page:e,
          pageSize:me.pageSize,
          companyId:user.companyId
        }
        if (user.companyId == 1) {
          data.companyId = '';
        }
        httpCom.newList(data).then(res => {
          me.data6 = res.data.dataList;
          me.data6.forEach(function (item,index) {
            if (item.state == 0) {
              me.$set(item,'shStatus','未审核');
            } else {
              me.$set(item,'shStatus','已审核');
            }
          })
          me.loading = false;
        })
      },
      edit(index){//编辑公告
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'公司管理','编辑公告');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        console.log(me.data6[index]);
        me.title = me.data6[index].title;
        me.remark = me.data6[index].content;
        me.xzid = me.data6[index].id;
        me.is_edit = true;
        me.modal1 = true;
      },
      delNew(index){//删除公告
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'公司管理','删除公告');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$confirm('此操作将删除该公告, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          me.$Loading.start();
          let user = JSON.parse(sessionStorage.getItem('user'));
          let data = {
            noticeId: me.data6[index].id,
            sign: user.sign,
            mobile:user.mobile
          };
          httpCom.delNew(data).then(res => {
            switch (res.code) {
              case '0000':
                me.data6.splice(index,1);
                me.$message.success('删除成功');
                me.$Loading.finish();
                break;
              case '1111':
                me.$message.error('删除失败');
                me.$Loading.error();
                break;
            }
          })
        })
      },
      onModel1(){//打开添加框
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'公司管理','添加公告');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.is_edit = false;
        me.modal1 = true;
      },
      add(){//点击确定
        var me = this;
        if (me.title == '') {
          me.$message.error('请输入标题');
          return false;
        }
        if (me.remark == '') {
          me.$message.error('请输入公告说明');
          return false;
        }
        me.$Loading.start();
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          userId:user.userId,
          content:me.remark,
          companyId:user.companyId,
          title:me.title
        }
        if (me.is_edit == true) {
          data['id'] = me.xzid;
        }
        httpCom.addNew(data).then(res => {
          switch (res.code) {
            case '0000':
              if (me.is_edit == true) {
                me.$message.success('修改成功');
              } else {
                me.$message.success('已提交审核');
              }
              let data = {
                mobile:user.mobile,
                sign:user.sign,
                page:me.page,
                pageSize:me.pageSize,
                companyId:user.companyId
              }
              if (user.companyId == 1) {
                data.companyId = '';
              }
              httpCom.newList(data).then(res => {
                me.data6 = res.data.dataList;
                me.data6.forEach(function (item,index) {
                  if (item.state == 0) {
                    me.$set(item,'shStatus','未审核');
                  } else {
                    me.$set(item,'shStatus','已审核');
                  }
                })
                me.total = res.data.totalNum;
              })
              me.$Loading.finish();
              break;
            case '1111':
              me.$message.error('添加失败');
              me.$Loading.error();
              break;
          }
        })
      }
    }
  }
</script>

<style scoped>
@import "company.css";
</style>